import { createStoreon } from 'storeon'
import { page } from '@garpix/fetcher/fetcher/storeon'
import {
  userModule,
  taskModule,
  ordersModule,
  certificatesModule,
  modalModule,
  atcModule,
  servicesModule,
  flyingListModule
} from './Modules'
import { Events, State } from '../interfaces'
import { statisticsModule } from './Modules/statisticsModule'

const store = createStoreon<State, Events>([
  userModule,
  ordersModule,
  certificatesModule,
  page,
  modalModule,
  taskModule,
  atcModule,
  statisticsModule,
  servicesModule,
  flyingListModule
])

export default store
